module.exports = __webpack_public_path__ + "img/bowl-chopsticks-noodles.18bb1573.svg";